import axios from "axios";
import Swal from "sweetalert2";
import { apiRoot, imgRoot, version } from "../config";

// Register once: direct axios calls (including login) need the same error handling.
axios.interceptors.response.use(undefined, error => {
  if (axios.isCancel(error)) return Promise.reject(error);
  const status = error?.response?.status;
  const message = error?.response?.data?.message || error?.response?.data?.info;
  let text;
  if (status === 401) {
    text = "Your session has expired. Please sign in again. (HTTP 401)";
  } else if (status) {
    text = typeof message === "string"
      ? `${message} (HTTP ${status})`
      : `The API request failed (HTTP ${status}). Please try again.`;
  } else if (error?.code === "ECONNABORTED" || error?.code === "ETIMEDOUT") {
    text = "The API request timed out. Please try again.";
  } else {
    text = `Cannot reach the API at ${apiRoot}. Check your connection and whether the API server is running.`;
  }
  Swal.fire({ icon: "error", title: "Request failed", text, confirmButtonText: "Close" });
  // Callers must be able to distinguish failure from a successful empty response.
  return Promise.reject(error);
});

const doRequest = async (path, params, method, activeToken, form = false) => {
  // Older services pass the token in the second argument of GET/DELETE.
  if ((method === "GET" || method === "DELETE") && typeof params === "string" && !activeToken) {
    activeToken = params;
    params = undefined;
  }
  const isForm = typeof FormData !== "undefined" && params instanceof FormData;
  const headers = {};
  if (activeToken) headers.Authorization = `Bearer ${activeToken}`;
  if (method !== "GET" && method !== "DELETE") {
    // A JSON header converts FormData to JSON in Axios, discarding file uploads.
    headers["Content-Type"] = isForm ? false : form ? "multipart/form-data" : "application/json";
  }
  const res = await axios({
    method: method.toLowerCase(), url: apiRoot + path, headers, timeout: 30000,
    ...(method === "GET" ? { params } : { data: params }),
  });
  if (res?.status === 204) return undefined;
  if (res?.data?.code < 1) {
    Swal.fire({ icon: "error", text: res.data.info, confirmButtonText: "Close" });
  }
  return res;
};

const get = (path, params, token) => doRequest(path, params, "GET", token);
const post = (path, params, token, form = false) => doRequest(path, params, "POST", token, form);

export default { get, post, apiRoot, imgRoot, version };
